import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ClienteService } from '../../services/cliente.service';
import { ClienteViewModel } from '../../models/viewmodels/clienteViewModel';
import { MovimientoViewModel } from '../../models/viewmodels/movimientoViewModel';
import { ListadoMovimientos, SaldoViewModel } from '../../models/viewmodels/listadoMovimientos';

import { DoubleBounceComponent } from '../../shared/spinners/double-bounce/double-bounce.component'
import { Router } from '@angular/router'

@Component({
  selector: 'app-aplicada',
  templateUrl: './aplicada.component.html',
  styleUrls: ['./aplicada.component.scss']
})
export class AplicadaComponent implements OnInit {

  cliente: ClienteViewModel;
  pagina: number = 0;
  cantidadPorPagina: number = 20;
  listado: ListadoMovimientos = new ListadoMovimientos();
  saldo:SaldoViewModel = new SaldoViewModel();
  paginas: number = 0;
  isLoading = true;

  alert: any = {
    tipo: "danger",
    titulo: "",
    mensaje: "",
    visible: false
  }

  @ViewChild(DoubleBounceComponent)
  spinner: DoubleBounceComponent;

  constructor(private clienteService: ClienteService, private router: Router, private authService: AuthService) {
    this.listado.movimientos = new Array<MovimientoViewModel>();
    this.cliente = this.clienteService.getCliente();
    if (!this.cliente) {
      if (this.authService.token && this.authService.roles.indexOf("administrador") == -1) {
        this.router.navigate(['clientes'])
      }else{
        this.router.navigate(['dashboard/clientes'])
      }
    }
    this.clienteService.clienteEmitter.subscribe(
      (cliente: ClienteViewModel) => {
        this.cliente = cliente;        
        this.obtenerMovimientos(0);
      });
  }

  ngOnInit() {
    this.obtenerMovimientos();
  }

  obtenerMovimientos(paginaActual?: number) {
    if (this.cliente) {
      this.pagina = paginaActual == null ? 0 : paginaActual;
      this.spinner.isRunning = true;
      this.clienteService.obtenerSaldo(this.cliente.id).subscribe(result =>{
        this.saldo = result;
      })
      this.clienteService.obtenerAplicada(this.cliente.id, this.pagina, this.cantidadPorPagina).subscribe(result => {
        this.spinner.isRunning = false;
        this.listado = result;
        if (this.listado && this.listado.total > 0) {
          this.paginas = Math.floor((this.listado.total + this.cantidadPorPagina - 1) / this.cantidadPorPagina);
        }
      });
    }
  }

  anterior() {
    this.obtenerMovimientos(this.pagina - 1);
  }

  siguiente() {
    this.obtenerMovimientos(this.pagina + 1);
  }

  buscar() {
    this.obtenerMovimientos();
  }

  obtenerComprobante(comprobante: string) {

    this.clienteService.obtenerComprobante(this.cliente.id, comprobante).subscribe(response => {
      let blob: Blob = response.blob();
      var fileURL = URL.createObjectURL(blob);
      window.open(fileURL);

    },
      error => {
        this.alert.visible = true;
        this.alert.titulo = "Error";
        this.alert.mensaje = `Se ha producido un error al descargar el comprobante ${comprobante}. Por favor vuelva a intentarlo.`
      });
  }

  historica(){
    if (this.authService.token && this.authService.roles.indexOf("administrador") == -1) {
        this.router.navigate(['/clientes/ctacte/historica'])
      }else{
        this.router.navigate(['/dashboard/clientes/ctacte/historica'])
      } 
  }

  paginate(event) {    
    //event.first = Index of the first record
    //event.rows = Number of rows to display in new page
    //event.page = Index of the new page
    //event.pageCount = Total number of pages
    this.obtenerMovimientos(event.page);
  }
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/clientes/aplicada/aplicada.component.ts